<div class="event-form__container">
  @if (isEventLocked()) {
    <mat-card class="event-form__locked-banner">
      <mat-card-content>
        <mat-icon>lock</mat-icon>
        <strong>This event is locked.</strong> Events cannot be edited once they
        have started.
      </mat-card-content>
    </mat-card>
  }
  <mat-stepper orientation="vertical" [linear]="true" #stepper>
    <mat-step [stepControl]="eventForm">
      <ng-template matStepLabel>Event Details</ng-template>
      <app-event-details-step
        [eventForm]="eventForm"
        [isEventLocked]="isEventLocked()"
      />
      <div class="event-form__actions">
        <button
          class="event-form__submit"
          mat-raised-button
          color="primary"
          (click)="onSubmit(false, stepper)"
          [disabled]="eventForm.invalid || isEventLocked()"
        >
          Next
        </button>
      </div>
    </mat-step>
    <mat-step [stepControl]="eventForm">
      <ng-template matStepLabel>Pricing Options</ng-template>
      <app-pricing-options-step
        [eventForm]="eventForm"
        [isEventLocked]="isEventLocked()"
        (addProductEvent)="addProduct()"
        (removeProductEvent)="removeProduct($event)"
      />
      <button
        class="event-form__submit"
        mat-raised-button
        color="primary"
        (click)="onSubmit(false, stepper)"
        [disabled]="products.invalid || isEventLocked()"
      >
        Next
      </button>
    </mat-step>
    <mat-step [stepControl]="eventForm">
      <ng-template matStepLabel>Add Sessions (Optional)</ng-template>
      <app-sessions-step
        [eventForm]="eventForm"
        [isEventLocked]="isEventLocked()"
        (addSessionEvent)="addSession()"
        (removeSessionEvent)="removeSession($event)"
      />
      <button
        class="event-form__submit"
        mat-raised-button
        color="primary"
        (click)="onSubmit(false, stepper)"
        [disabled]="eventForm.invalid || isEventLocked()"
      >
        Next
      </button>
    </mat-step>
    <mat-step [stepControl]="eventForm">
      <ng-template matStepLabel>Accepted Payment Types (Optional)</ng-template>
      <app-payment-type-step
        [eventForm]="eventForm"
        [isEventLocked]="isEventLocked()"
        [eventCost]="getEventCost()"
        [eventUpcomingCharge]="getEventUpcomingCharge()"
        [isEventPaid]="isEventPaid()"
        [stripeError]="stripeError"
        [submitted]="formSubmitted"
      />
      <button
        class="event-form__submit"
        mat-raised-button
        color="primary"
        (click)="onSubmit(true, stepper)"
        [disabled]="eventForm.invalid || isEventLocked()"
      >
        Save
      </button>
    </mat-step>
  </mat-stepper>
</div>
